<template>
	<div class="wrapper">
		<h1>Qunbi Zhuge's Awards/Honors</h1>
		<!-- <ul class="list">
			<li v-for="(item, idx) in list" :key="idx">
				<p>{{ item }}</p>
			</li>
		</ul> -->
		
		
		<!-- <a
			class="list"
			v-for="(item, idx) in list"
			:key="idx"
			:href="item.noLink ? 'javascript:void(0)' : item.link"
			:target="!item.noLink && '_blank'"
		>
			<li>
				<span class="title">{{ item.title }}</span>
			</li>
		</a> -->
		<ul class = 'list'>
			<li v-for="(item, idx) in list" :key="idx"> 
				<a
					class = "honorList"
					:href="item.noLink ? 'javascript:void(0)' : item.link"
					:target="!item.noLink && '_blank'"
				>
					<span class="title">{{ item.title }}</span>
				</a>
			</li>
		</ul>

	</div>
</template>

<script>
export default {
	data() {
		return {
			list: [
				{ title: '2026, Optica Fellow',link: 'https://mp.weixin.qq.com/s/0TcCeFCQZsFVsxqWuOzBRA'},
			    { title: '2024, SJTU Teaching Achievement Award (the first award)', link: ''},
			    { title: '2024, SJTU Teaching Achievement Award (the second award)', link: ''},
				{ title: '2024, SJTU Excellent Teaching Award', link: 'https://news.sjtu.edu.cn/jdyw/20241111/203911.html'},
				{ title: '2024, Excellent Bachelor Thesis Supervisor of Shanghai Jiao Tong University (Top 1%)', link: "https://mp.weixin.qq.com/s/9i1Ei-wx8mBmiQYDzQIJWQ"},
				{ title: '2024, Corning Women Scholar in Optical Fiber Communications Conference (OFC) (as the Supervisor)', link: 'https://mp.weixin.qq.com/s/l21XwOTnEnJeExDjfxXsww'},
				{ title: '2023, International Society for Optics and Photonics (SPIE) Optics & Photonics Education Scholarship (as the Supervisor)', link: 'https://news.sjtu.edu.cn/jdyw/20230628/185321.html'},
				{ title: '2022, Best Student Paper Award in International Conference on Optical Communications and Networks (ICOCN) (as the Supervisor)', link: 'https://news.sjtu.edu.cn/jdyw/20221106/176005.html'},
				{ title: '2022, Excellent Bachelor Thesis Supervisor of Shanghai Jiao Tong University (Top 1%)', link: "https://www.seiee.sjtu.edu.cn/index_news/1223.html"},
				{ title: '2021, Best Student Paper Award in Asia Communications and Photonics (ACP) Conference (as the Supervisor)', link: "https://mp.weixin.qq.com/s?__biz=MzA3Nzg4NzM4Mw==&mid=2460586346&idx=1&sn=d8cd262cf1cdaef399508fc7d3b41e07&chksm=88161392bf619a8459416f6655ef31b5b06a6ab81c0a9b2a8c5b4677d38625894fce3cdc294d&token=787713613&lang=zh_CN#rd"},
				{ title: '2021, OSA Student Paper Award Winner in Advanced Photonics Congress (as the Supervisor)', link: "https://mp.weixin.qq.com/s/Zml5NyDUCLsbEdyLHiJHCg"},
				{ title: '2020, “Innovators Under 35” of MIT Technology Review in China', link: 'https://www.innovatorsunder35.com/the-list/2020/china/telecommunications'},
				{ title: '2020, Grand Prize Winner for the Corning Outstanding Student Paper Competition in Optical Fiber Communications Conference (OFC) (as the Supervisor)', link: 'https://www.ofcconference.org/en-us/home/news-and-press/press-releases/press-releases-archive/2020/mengfan-fu-named-2020-corning-outstanding-student/'},
				{ title: '2020, Excellent Bachelor Thesis Supervisor of Shanghai Jiao Tong University (Top 1%)', link: 'https://ee.sjtu.edu.cn/Show.aspx?infolb=91&infoid=1249&flag=46'},
				{ title: '2020, Best Poster Award in Asia Communications and Photonics (ACP) Conference (as the Supervisor)', link: 'https://mp.weixin.qq.com/s/ufwJLeU8Rs6PCOl_FLFZhg'},
				{ title: '2020, Second Prize in HUA WEI CUP National Undergraduate IOT Design Contest (as the Supervisor)', link: 'https://mp.weixin.qq.com/s/9Rz8vlGc_qq-zLeWk1N-ng'},
				{ title: '2019, Excellent Cooperation Award with Huawei', link: 'https://ee.sjtu.edu.cn/Show.aspx?infolb=91&infoid=1205&flag=46'}, 
				{ title: '2015-2016, Top 10 Reviewers of IEEE/OSA Journal of Lightwave Technology', link:''},
				{ title: '2016, OSA Outstanding Reviewer Recognition', link:''},
				{ title: '2014, NSERC Postdoctoral Fellowship (Declined)', link:''},
				{ title: '2013, Chinese Government Award for Outstanding Self-Financed Student Abroad', link: ''},
				{ title: '2013, IEEE Photonics Society Graduate Student Fellowships (1 of 10, Worldwide)', link: ''},
				{ title: '2013, SPIE Optics and Photonics Education Scholarship (International)', link: ''},
				{ title: '2012, First Prize of Best Student Paper in Asia Communications and Photonics Conference (International)', link:''},
				{ title: '2012, Corning Outstanding Student Paper Competition Finalist (top 6) in Optical Fiber Communications Conference (OFC) (International)', link: ''},
				{ title: '2012-2015, McGill Engineering Doctoral Award (International)', link:''}
			]
		}
	}
}
</script>

<style scoped lang="scss">
h1 {
	font-size: 28px;
	// font-family: PingFang SC;
	font-family: 'Times New Roman', Times, serif;
	font-weight: 650;
	line-height: 22px;
	color: #04111f;
	margin-bottom: 35px;
}
.list {
	padding-left: 20px;
	.honorList{
		.title{
			font-weight: 500;
			font-family: 'Times New Roman', Times, serif;
			line-height: 39px;
			color: #000000;
			font-size: 18px;
			margin-bottom: 21px;
		}
	// 	span {
		
	// }
	}
	
	// a {
	// 	font-weight: 500;
	// 	line-height: 28px;
	// 	color: #000000;
	// 	font-size: 16px;
	// 	margin-bottom: 8px;
	// }
	// color: #04111f;
}
</style>